import { Icon } from 'components/Icon';
import {
  CardHeader,
  CardSubtitle,
  CardTitle,
  HeaderIcon,
  SummaryCard,
} from '../../styled';
import {
  ItemLabel,
  ItemValue,
  PmtBanner,
  PmtIcon,
  PmtLabel,
  PmtSubtitle,
  PmtText,
  PmtValue,
  SummaryGrid,
  SummaryItem,
} from './styled';

// Blocos do resumo a partir do `summary` do modal de renegociacao, preenchido
// no `calc` e no `calcCet` — o estado do FormCore nao e reativo para quem esta
// fora dele.
export const buildSimulationItems = (summary) => [
  {
    icon: 'percent',
    label: 'CET',
    value: summary?.cet ? `${summary.cet}%` : null,
  },
  { icon: 'receipt_long', label: 'TAC', value: summary?.tac },
  { icon: 'shield', label: 'Seguro Prestamista', value: summary?.seguro },
  {
    icon: 'shield',
    label: 'Seguro Assistência',
    value: summary?.seguroAssis,
  },
  { icon: 'percent', label: 'IOF?', value: summary?.iofSN },
  { icon: 'account_balance', label: 'IOF', value: summary?.iof },
  {
    icon: 'percent',
    label: 'Taxa Serviço',
    value:
      summary?.tabPerc !== undefined && summary?.tabPerc !== null
        ? `${summary.tabPerc}%`
        : null,
  },
  { icon: 'payments', label: 'Taxa Serviço', value: summary?.tab },
];

// Card de resumo de uma renegociacao, somente leitura: a PMT em destaque e os
// demais valores em blocos `{ icon, label, value }`. Serve a simulacao do modal
// de renegociacao e a aba Renegociacao do Historico, que mostra os dados de
// uma renegociacao ja concluida.
export default function SimulationSummary({
  pmt,
  items = [],
  title = 'Resumo da Simulação',
  subtitle = 'Valores calculados com base nas informações da oferta.',
}) {
  return (
    <SummaryCard>
      <CardHeader $tinted>
        <HeaderIcon>
          <Icon name="bar_chart" size={22} />
        </HeaderIcon>
        <div>
          <CardTitle>{title}</CardTitle>
          <CardSubtitle>{subtitle}</CardSubtitle>
        </div>
      </CardHeader>

      <PmtBanner>
        <PmtIcon>
          <Icon name="payments" size={20} />
        </PmtIcon>
        <PmtText>
          <PmtLabel>PMT (Parcela Mensal)</PmtLabel>
          <PmtSubtitle>Valor da parcela com base na simulação</PmtSubtitle>
        </PmtText>
        <PmtValue>{pmt || '-'}</PmtValue>
      </PmtBanner>

      <SummaryGrid>
        {items.map((item) => (
          <SummaryItem key={item.label}>
            <ItemLabel title={item.label}>
              <Icon name={item.icon} size={14} />
              {item.label}
            </ItemLabel>
            <ItemValue>{item.value ?? '-'}</ItemValue>
          </SummaryItem>
        ))}
      </SummaryGrid>
    </SummaryCard>
  );
}
